export const GET_ALL_WEBSITE_PACKAGE_DATA = "GET_ALL_WEBSITE_PACKAGE_DATA"

export const GET_WEBSITE_PACKAGE = "GET_WEBSITE_PACKAGE"

export const CLEAR_GET_WEBSITE_PACKAGE = "CLEAR_GET_WEBSITE_PACKAGE"